import { Text, Button, space } from '@ticketswap/solar'
import styled from '@emotion/styled'
import { Translate } from '~/types/Translation'
import { RouteMap } from '~/lib/routeMap'
import { track } from '~/utils/analytics'
import { useRouter } from 'next/router'
import { VERIFICATION_FLOW_DISMISSED, VERIFICATION_FLOW_STARTED } from '~/lib/tracking-events'

const Content = styled.div`
  display: grid;
  grid-gap: ${space[32]};
`

const Buttons = styled.div`
  display: grid;
  grid-gap: ${space[8]};
`

interface Props {
  t: Translate
  onComplete: () => void
  hide: () => void
}

const AccountVerification = ({ t, onComplete, hide }: Props) => {
  const { asPath, push } = useRouter()

  const handleHide = async () => {
    await track(VERIFICATION_FLOW_DISMISSED, {
      path: asPath,
    })

    onComplete()
    hide()
  }

  const handleStartFlow = async () => {
    await track(VERIFICATION_FLOW_STARTED, {
      path: asPath,
    })

    push(RouteMap['VERIFICATION_FLOW_PHONE'])
  }

  return (
    <Content>
      <Text as="p">{t('common:auth.accountVerification.text')}</Text>

      <Buttons>
        <Button variant="primary" onClick={handleStartFlow}>
          {t('common:auth.accountVerification.button')}
        </Button>

        <Button variant="inverted" onClick={handleHide}>
          {t('common:auth.accountVerification.hide')}
        </Button>
      </Buttons>
    </Content>
  )
}

export default AccountVerification
